import Vue from 'vue';
import Vuex from 'vuex';
import vuexCache from 'vuex-cache';
import core from '@/apps/core/store';
import auth from '@/apps/auth/store';
import kiosk from '@/apps/kiosk/store';
import cordova from '@/apps/cordova/store';
import desktop from '@/apps/desktop/store';
import cart from '@/apps/cart/store';
import menu from '@/apps/menu/store';
import configurator from '@/apps/configurator/store';

Vue.use(Vuex);
Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.devtool = 'eval-source-map';

const state = {};
const getters = {};
const actions = {};
const mutations = {};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    core,
    cart,
    auth,
    kiosk,
    cordova,
    desktop,
    menu,
    configurator,
  },
  plugins: [
    vuexCache,
  ],
});



// WEBPACK FOOTER //
// ./src/store/index.js